import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { FieldWithLabel } from '../../../../../components/FieldWithLabel/FieldWithLabel'
import { BTN_TXT } from '../../../../../constants'
import { ACTIONS, contractSubject, SUBJECTS } from '../../../Abilities'
import {
  Can,
  useContractDetailsAbility
} from 'features/ContractDetails/Providers/ContractDetailsAbilityProvider'
import { useContractDetailsContext } from '../../../Providers/ContractDetailsContextProvider'
import { ReactComponent as Plus16 } from '../../../../../assets/svg/Plus16.svg'
import { ReactComponent as Edit16 } from '../../../../../assets/svg/Edit16.svg'
import { useContractDetailsPopup } from '../../../Providers/ContractDetailsPopupProvider'
import { Note } from './Note'
import cn from 'classnames'

export const ViewNoteButton = () => {
  const contractDetails = useContractDetailsContext()
  const { details } = contractDetails.state

  const { addNotePopup } = useContractDetailsPopup()
  const ability = useContractDetailsAbility()

  const canEditNote = ability.can(
    ACTIONS.EDIT,
    contractSubject(SUBJECTS.NOTE, details)
  )

  if (!canEditNote && !details.note) return null

  return (
    <Can I={ACTIONS.VIEW} a={contractSubject(SUBJECTS.NOTE, details)}>
      <FieldWithLabel
        title={
          <div className="row gap-8 align-center">
            <span>Contract Note</span>
            {canEditNote && details.note && (
              <Button
                type={BUTTON_TYPES.GHOST}
                icon={<Edit16 className="attachment__icon" />}
                onClick={() => addNotePopup.actions.open()}
                medium
                upperCase
              />
            )}
          </div>
        }
        className={cn({
          'full-row': details.note?.text
        })}
      >
        {details.note ? (
          <Note note={details.note} />
        ) : (
          <Button
            type={BUTTON_TYPES.GHOST}
            icon={<Plus16 className="attachment__icon" />}
            onClick={() => addNotePopup.actions.open()}
            medium
            upperCase
          >
            {BTN_TXT.ADD_NOTE}
          </Button>
        )}
      </FieldWithLabel>
    </Can>
  )
}
